var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.743 18.814l-7.779-7.778c-.39-.391-.39-1.024 0-1.415.391-.39 1.024-.39 1.415 0l6.364 6.364 6.364-6.364c.39-.39 1.023-.39 1.414 0 .39.39.39 1.024 0 1.415l-7.778 7.778z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDI4IDI4Ij4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTMuNzQzIDE4LjgxNGwtNy43NzktNy43NzhjLS4zOS0uMzkxLS4zOS0xLjAyNCAwLTEuNDE1LjM5MS0uMzkgMS4wMjQtLjM5IDEuNDE1IDBsNi4zNjQgNi4zNjQgNi4zNjQtNi4zNjRjLjM5LS4zOSAxLjAyMy0uMzkgMS40MTQgMCAuMzkuMzkuMzkgMS4wMjQgMCAxLjQxNWwtNy43NzggNy43Nzh6Ii8+Cjwvc3ZnPgo=";
export { SvgIconArrowBottom as ReactComponent };